import { EmailAction } from '../types';

/**
 * Ordre d'exécution réel côté serveur : TAG → FORWARD → UPLOAD → MOVE → DELETE
 * (CLAUDE.md, « Action execution order »). L'API renvoie les actions dans l'ordre
 * d'écriture en base, qui ne le suit pas toujours : on les retrie pour que la
 * chronologie affichée soit celle de l'exécution.
 *
 * L'API envoie le type en minuscules (`add_category`) ; on normalise.
 */
export const ORDRE_ACTIONS = ['ADD_CATEGORY', 'FORWARD_EMAIL', 'UPLOAD_ATTACHMENT', 'MOVE_EMAIL', 'DELETE_EMAIL'];

export const typeAction = (a: Pick<EmailAction, 'action_type'>): string =>
  (a.action_type || '').toUpperCase();

export const trierActions = <T extends Pick<EmailAction, 'action_type'>>(actions: T[]): T[] => {
  const rang = (a: T) => {
    const i = ORDRE_ACTIONS.indexOf(typeAction(a));
    return i === -1 ? ORDRE_ACTIONS.length : i;
  };
  return actions
    .map((a, i) => ({ a, i }))
    .sort((x, y) => rang(x.a) - rang(y.a) || x.i - y.i)
    .map(({ a }) => a);
};

export const ACTIONS: Record<string, { libelle: string; icone: string; couleur: string }> = {
  ADD_CATEGORY:      { libelle: 'Tag',        icone: 'bi-tag-fill',             couleur: '#0d6efd' },
  FORWARD_EMAIL:     { libelle: 'Transfert',  icone: 'bi-forward-fill',         couleur: '#0aa2c0' },
  UPLOAD_ATTACHMENT: { libelle: 'SharePoint', icone: 'bi-cloud-upload-fill',    couleur: '#198754' },
  MOVE_EMAIL:        { libelle: 'Dossier',    icone: 'bi-folder-symlink-fill',  couleur: '#b98900' },
  DELETE_EMAIL:      { libelle: 'Suppression', icone: 'bi-trash-fill',          couleur: '#dc3545' },
};

export const presentationAction = (a: Pick<EmailAction, 'action_type'>) =>
  ACTIONS[typeAction(a)] || { libelle: a.action_type || '?', icone: 'bi-gear-fill', couleur: '#6c757d' };

/**
 * La cible de l'action, sans le préfixe que le serveur met dans `details`
 * (« Tag: », « To: », « Folder: », « SP: », « Moved to folder: »...).
 */
export const cibleAction = (a: Pick<EmailAction, 'action_type' | 'details'>): string => {
  const d = (a.details || '').trim();
  if (typeAction(a) === 'DELETE_EMAIL') return '';
  const m = d.match(/^(?:[\w\s]*?(?:tag|categor(?:y|ie)|to|folder|sp|dossier))\s*:\s*(.+)$/i);
  return (m ? m[1] : d).trim();
};
